import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

export interface TrashIconButtonProps {
    onClick: () => void;
    className?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
}

/**
 * TrashIconButton component for consistent trash/delete button styling
 * Uses the standard trash icon with themed error color
 */
export const TrashIconButton: React.FC<TrashIconButtonProps> = ({
    onClick,
    className,
    style,
    disabled = false
}) => {
    const theme = useTheme();

    const buttonStyle: React.CSSProperties = {
        backgroundColor: theme.colors.status.error,
        color: theme.colors.text.inverse,
        border: 'none',
        borderRadius: theme.borderRadius.sm,
        padding: theme.spacing.sm,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style
    };

    return (
        <button
            className={className}
            style={buttonStyle}
            onClick={onClick}
            disabled={disabled}
        >
            <i className="fas fa-trash"></i>
        </button>
    );
};
